"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFocusEventListener = void 0;
var _react = require("react");
/**
 * Listens to certain events to turn focus on or off. It will performantly add/remove event
 * handlers so we aren't always listening to mouse AND keyboard events, just one or the other.
 * This goes hand in hand with useFocusMode.
 */
const useFocusEventListener = _ref => {
  let {
    focusMode,
    keyCodes,
    keyEvents,
    mouseEvents,
    setFocusMode
  } = _ref;
  const setKeyboard = (0, _react.useCallback)(event => {
    // Only pay attention to certain keys.
    if (keyCodes.has(event.key)) {
      setFocusMode("keyboard");
    }
  }, [keyCodes, setFocusMode]);
  const setMouse = (0, _react.useCallback)(() => setFocusMode("mouse"), [setFocusMode]);
  const watchForKeyboardOn = (0, _react.useCallback)(() => {
    keyEvents.forEach(eventName => {
      document.body.addEventListener(eventName, setKeyboard);
    });
  }, [setKeyboard, keyEvents]);
  const watchForKeyboardOff = (0, _react.useCallback)(() => {
    keyEvents.forEach(eventName => {
      document.body.removeEventListener(eventName, setKeyboard);
    });
  }, [setKeyboard, keyEvents]);
  const watchForMouseOn = (0, _react.useCallback)(() => {
    mouseEvents.forEach(eventName => {
      document.body.addEventListener(eventName, setMouse);
    });
  }, [setMouse, mouseEvents]);
  const watchForMouseOff = (0, _react.useCallback)(() => {
    mouseEvents.forEach(eventName => {
      document.body.removeEventListener(eventName, setMouse);
    });
  }, [setMouse, mouseEvents]);
  (0, _react.useLayoutEffect)(() => {
    switch (focusMode) {
      case "mouse":
        watchForKeyboardOn();
        break;
      case "keyboard":
        watchForMouseOn();
        break;
    }
    return () => {
      watchForKeyboardOff();
      watchForMouseOff();
    };
  }, [focusMode, watchForKeyboardOff, watchForKeyboardOn, watchForMouseOff, watchForMouseOn]);
};
exports.useFocusEventListener = useFocusEventListener;
//# sourceMappingURL=useFocusEventListener.js.map